import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TestSteps, TestTypes } from "@Constants/app.constant";
import { InstructionIndex } from "../MockTest/Instruction";
import { SpeedTestCard } from "./SpeedTestCard/SpeedTestCard";
import { AppRouteURL, TestRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { getTestDetails, getTestSeriesDetails } from "../TestDetails/services/TestDetails.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";

export const SppedTestIndex = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const testId = params.testId;
  const examId = params.examId;
  // const timeDuration = Number(searchParams.get('duration'));
  const timeDuration = Number(location.state?.duration);
  const [testDeatils, setTestDeatils] = useState<any>([]);
  const [step, setStep] = useState(0);
  const [isTestSeries, setIsTestSeries] = useState<boolean>(false);
  const testType = TestTypes.speed;

  useEffect(() => {
    if (location.pathname.includes(`${TestRouteURL.SPEED_TEST_SERIES}`) || location.pathname.includes(`${TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES}`) || location.pathname.includes(`${TestSereisRouteURL.FULL_MOCK_SPEED_TEST_SERIES}`) || location.pathname.includes(`${TestSereisRouteURL.PREVIOUS_YEAR_MOCK_SPEED_TEST_SERIES}`)) {
      setIsTestSeries(true);
      getAllTestSeriesDetails();
    } else {
      setIsTestSeries(false);
      getAllTestDetails();
    }
  }, [testId, examId]);

  function getAllTestDetails() {
    let param = {
      "testId": testId,
    }
    getTestDetails(param).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS && location.state?.flagTest == testId) {
        let data = response?.data;
        setTestDeatils(data);
        setStep(TestSteps.INSTRUCTION)
      } else if (response?.ResponseType === "DATA_NOT_FOUND" && !response?.data) {
        navigate(AppRouteURL.NOT_FOUND);
      } else {
        navigate(AppRouteURL.NOT_FOUND)
      }
    }).catch((error) => {
      console.log(error);
      navigate(AppRouteURL.NOT_FOUND)
    })
  }
  function getAllTestSeriesDetails() {
    let param = {
      "examId": examId,
    }
    getTestSeriesDetails(param).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS && location.state?.flagTest == examId) {
        let data = response?.data;
        setTestDeatils(data);
        setStep(TestSteps.INSTRUCTION)
      } else if (response?.ResponseType === "DATA_NOT_FOUND" && !response?.data) {
        navigate(AppRouteURL.NOT_FOUND);
      } else {
        navigate(AppRouteURL.NOT_FOUND)
      }
    }).catch((error) => {
      console.log(error);
      navigate(AppRouteURL.NOT_FOUND)
    })
  }

  const onContinueClickHandler = () => {
    setStep(TestSteps.START_TEST);
  }

  const isDiagnostic = location.pathname.includes(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES);

  return (
    <>
      {step == TestSteps.INSTRUCTION ?
        isTestSeries ?
          <InstructionIndex maxMarks="0" noOfQuestion="0" timeDuration={timeDuration} onContinueClickHandler={onContinueClickHandler} testType={testType} isTestSeries={isTestSeries} testName={testDeatils.Name} isDiagnostic={isDiagnostic} instruction={testDeatils.Instruction}/>
          : <InstructionIndex maxMarks="0" noOfQuestion="0" timeDuration={timeDuration} onContinueClickHandler={onContinueClickHandler} testType={testType} isTestSeries={isTestSeries} testName={testDeatils[0].TestName} isDiagnostic={isDiagnostic} instruction={testDeatils[0].Instruction}/>
        : ''}
      {step == TestSteps.START_TEST ?
        isTestSeries ?
          <SpeedTestCard testId={examId} noOfQuestion="0" timeDuration={timeDuration} isTestSeries={isTestSeries} testIds={testDeatils.TestIdList} generalInstruction={testDeatils.Instruction}/>
          : <SpeedTestCard testId={testId} noOfQuestion="0" timeDuration={timeDuration} isTestSeries={isTestSeries} testIds={[]} generalInstruction={testDeatils[0].Instruction}/>
        : ''}

    </>
  );
};
